module.exports = __webpack_public_path__ + "static/media/siddharth-tirupati-trip-11.b4902ee3.png";